export type UserOnboardingSortBy =
  | 'first_name'
  | 'last_name'
  | 'email'
  | 'title'
  | 'phone_number'
  | 'invite_time'
  | 'last_login_time';

/**
 * Array of all UserOnboardingSortBy values.
 */
export const USERONBOARDINGSORTBY_VALUES: readonly UserOnboardingSortBy[] = [
  'first_name',
  'last_name',
  'email',
  'title',
  'phone_number',
  'invite_time',
  'last_login_time',
] as const;
